import TIcon from "views/components/icons/TIcon";
import ImageIcon from "views/components/icons/ImageIcon";
import TriangleIcon from "views/components/icons/TriangleIcon";
import BackgroundIcon from "views/components/icons/BackgroundIcon";
import GridIcon from "views/components/icons/GridIcon";
import TableIcon from "views/components/icons/TableIcon";
import CurvedTextIcon from "views/components/icons/CurvedTextIcon";
import VideoIcon from "views/components/icons/VideoIcon";
import AudioIcon from "views/components/icons/AudioIcon";
import QRIcon from "views/components/icons/QRIcon";
import NoComponent from "views/components/NoComponent";
import LineIcon from "views/components/icons/LineIcon";
import FolderIcon from "views/components/icons/FolderIcon";
import { memoize } from "lib";

export const elementIconMap = {
  vector: TriangleIcon,
  image: ImageIcon,
  video: VideoIcon,
  audio: AudioIcon,
  background: BackgroundIcon,
  textbox: TIcon,
  caption: TIcon,
  grid: GridIcon,
  table: TableIcon,
  table2: TableIcon,
  vectortext: CurvedTextIcon,
  qrcode: QRIcon,
  line: LineIcon,
  group: FolderIcon
};

export const getElementIcon = type => {
  let icon = elementIconMap[type];

  if (!icon) {
    icon = NoComponent;
  }

  return icon;
};

export const memoizedGetElementIcon = memoize(getElementIcon, type => type);
